/* eslint-disable */
export default {
  _cf_samurai_bobregular: 'cf_samurai_bobregular',
}